






















import { Vue, Component, Prop } from "vue-property-decorator";
import { NotaAzienda } from "@/_models/notaAzienda";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class NotaAziendaCreate extends Vue {
    @Prop() idAzienda!: number;
    @Prop() idIstituto!: number;
    private nota: string;

    private notaRules: [boolean | string];

    constructor() {
        super();
        this.nota = "";

        this.notaRules = [true];
    }

    validazioneNota() {
        var valid: boolean = false;
        if (this.nota === "") {
            this.notaRules = [true];
        } else {
            valid = /^[a-zA-Z0-9ìèéùòà,.'\x20]{2,}$/.test(this.nota);
            if (valid) {
                this.notaRules = [true];
            } else {
                this.notaRules = [
                    "Nota non deve contenere caratteri speciali"
                ];
            }
        }
    }

    close() {
        this.nota = "";
        this.notaRules = [true];
        bus.$emit("closeCreateDialog");
    }

    async executeTest() {
        this.validazioneNota();
    }

    save() {
        this.executeTest().then(() => {
            if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
                var userInfo = user.readUserInfo(this["$store"]);
                var payload: NotaAzienda = {
                    idNota: 0,
                    idAzienda: this.idAzienda,
                    idIstituto: this.idIstituto,
                    nota: this.nota,
                    dataCreazione: new Date().toISOString(),
                    idUtenteIstituto: userInfo.idUtente,
                    utenteIstituto: {}
                };
                user.dispatchCreateNotaAzienda(this["$store"], payload)
                .then(() => {
                    bus.$emit("successfullOperation", "Nota creata con successo");
                    this.close();
                    bus.$emit("loadNoteAzienda");
                })
                .catch(error => {
                    if (error.response.status === 403) {
                        bus.$emit("errorOperation", error.response.statusText);
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", error.response.statusText);
                    }
                });
            }
        });
    }
}
